<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useRoute, useRouter } from 'vue-router';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';
import SalesReviewReturnHeader from '../components/SalesReviewReturnHeader.vue';
import SalesTransactionDetailContent from '../components/SalesTransactionDetailContent.vue';
import { useSalesTransactionDetail } from '../composables/useSalesTransactionDetail';

const { t } = useI18n();
const route = useRoute();
const router = useRouter();
const id = computed(() => route.params.salesTransactionId?.toString() || '');
const detail = useSalesTransactionDetail({ id, t });

const backToSupport = () =>
  router.push({
    name: 'operacao_imobiliaria_apoio',
    params: { accountId: route.params.accountId },
  });
</script>

<template>
  <div class="min-h-full bg-lais-bg-soft">
    <SalesReviewReturnHeader
      v-if="detail.transaction.value"
      read-only
      :transaction="detail.transaction.value"
      @back="backToSupport"
    />

    <main
      class="mx-auto flex w-full max-w-[1500px] flex-col gap-5 px-4 py-6 sm:px-6 lg:px-10"
    >
      <div
        v-if="detail.loading.value"
        class="rounded-lais border border-lais-border-soft bg-white p-8 text-center text-sm text-lais-text-muted"
      >
        {{ t('SALES.COMMON.LOADING') }}
      </div>
      <section
        v-else-if="detail.error.value"
        class="rounded-lais border border-lais-danger/30 bg-white p-6 text-center"
      >
        <p class="text-sm text-lais-danger">{{ detail.error.value }}</p>
        <LaisPrimaryButton class="mt-4" variant="ghost" @click="backToSupport">
          {{ t('SALES.ACTIONS.BACK') }}
        </LaisPrimaryButton>
      </section>
      <SalesTransactionDetailContent
        v-else-if="detail.transaction.value"
        :initial-tab="route.query.detail_tab || 'sale'"
        :show-nucleo-link="false"
        :show-summary="false"
        :transaction="detail.transaction.value"
      />
    </main>
  </div>
</template>
